import { NO_VALUE_SELECTED_ERROR } from '../../utils/formValidation/commonErrorConstants';
import { getCharMinMessage, getReqMessage } from '../../utils/formValidation/errorMessageFunctions';

export const NOTE_MIN_CHAR = 10;
export const NOTE_CHAR_LIMIT = 750;
export const EVENT_DESCRIPTION = 'Event description';
export const EVENT_DATE = 'Event date';
export const EVENT_TIME = 'Event time';

export const initialErrorState = {};

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.itemTypeId) {
        newErrors = {
            ...newErrors,
            itemTypeId: { error: true, message: NO_VALUE_SELECTED_ERROR }
        };
    }

    if (newEntry.notes.trim().length < NOTE_MIN_CHAR) {
        newErrors = {
            ...newErrors,
            notes: { error: true, message: getCharMinMessage(EVENT_DESCRIPTION, NOTE_MIN_CHAR) }
        };
    }

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage(EVENT_DATE) }
        };
    }

    if (!newEntry.eventTime) {
        newErrors = {
            ...newErrors,
            eventTime: { error: true, message: getReqMessage(EVENT_TIME) }
        };
    }

    return newErrors;
};
